import { Box, Container, Typography } from '@mui/material';
import { FindPatientsManagement } from 'components/templates';
import React from 'react';

export const FindPatientsView = () => {
  return (
    <Container component="main" maxWidth="xl" sx={{ width: '75%' }}>
      <Box>
        <Typography variant="h4" component="h1" gutterBottom sx={{ textAlign: 'left' }}>
          Find Patients
        </Typography>
      </Box>
      <FindPatientsManagement />
    </Container>
  );
};
